import { Edit3, Save, X, Trash2 } from "lucide-react";

export default function AdminEditWrapper({ 
  children, 
  isAdmin, 
  isEditing, 
  onEdit, 
  onSave, 
  onCancel,
  onDelete,
  showDelete = false
}) {
  if (!isAdmin) {
    return children;
  }

  return (
    <div 
      className="relative group"
      style={{ 
        border: isEditing ? "1px dashed var(--mm-gold)" : "1px dashed transparent",
        padding: isEditing ? "8px" : "0",
        borderRadius: "8px",
        transition: "all 0.3s ease"
      }}
    >
      {children}
      
      {!isEditing && (
        <div 
          className="absolute top-2 right-2 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          style={{ zIndex: 10 }}
        >
          <button
            onClick={onEdit}
            className="p-2 rounded-lg transition-all hover:scale-110"
            style={{ 
              backgroundColor: "rgba(47, 216, 168, 0.2)",
              border: "1px solid var(--mm-gold)"
            }}
            data-testid="edit-btn"
          >
            <Edit3 size={16} style={{ color: "var(--mm-gold)" }} />
          </button>
          {showDelete && onDelete && (
            <button
              onClick={onDelete}
              className="p-2 rounded-lg transition-all hover:scale-110"
              style={{ 
                backgroundColor: "rgba(239, 68, 68, 0.2)",
                border: "1px solid #EF4444"
              }}
              data-testid="delete-btn"
            >
              <Trash2 size={16} style={{ color: "#EF4444" }} />
            </button>
          )}
        </div>
      )}
      
      {isEditing && (
        <div className="flex gap-2 mt-4 justify-end">
          <button
            onClick={onSave}
            className="flex items-center gap-2 px-4 py-2 rounded-lg transition-all"
            style={{ 
              backgroundColor: "var(--mm-gold)",
              color: "#000",
              fontFamily: "'Space Grotesk', sans-serif",
              fontWeight: 600
            }}
            data-testid="save-edit-btn"
          >
            <Save size={16} />
            Salva
          </button>
          <button
            onClick={onCancel}
            className="flex items-center gap-2 px-4 py-2 rounded-lg transition-all"
            style={{ 
              backgroundColor: "transparent",
              border: "1px solid var(--mm-border)",
              color: "var(--mm-text-primary)",
              fontFamily: "'Space Grotesk', sans-serif",
              fontWeight: 600
            }}
            data-testid="cancel-edit-btn"
          >
            <X size={16} />
            Annulla
          </button>
        </div>
      )}
    </div>
  );
}
